import React, { Component } from 'react';
import './../PersonRegist.css'
import Api from '../../../api/wxapi';

import './../config'
import intl from 'react-intl-universal';
import Select from 'react-select';
import { inject, observer } from 'mobx-react';



let Timer = null


@inject('store')
@observer
export default class FaultPost extends Component {
    constructor(props) {
        super();
        this.state = {

            username: '',
            selectitem: null
        };


    }

    componentDidMount() {
        document.title = 'vip充值'
        let openid = sessionStorage.getItem('openid')

        if (openid && openid.length > 0) {

            sessionStorage.setItem('openid', openid, { path: '/' })
            this.wxconfig()
        } else {
            this.wxrz();
        }

    }
    render() {
        let {

            username,
            selectitem

        } = this.state

        let arr = [{ text: '0.1元', value: '0.1' }, { text: '0.5元', value: '0.5' }, { text: '1元', value: '1' }, { text: '2元', value: '2' }]
        let _self = this
        return (
            <div className='flex-column-container-screen' style={{ paddingLeft: 12, paddingRight: 12,backgroundColor: '#fff' ,paddingBottom:12}}>

                <div className='itemContaier'>
                    <p className='itemname'>{'充值账号'}</p>
                    <input className="inputbox" type="text" value={username} onChange={event => this.setState({ username: event.target.value })} placeholder={'请输入充值账号'} />
                </div>

                <p className='itemname' style={{ marginTop: '10px' }}>{'充值金额'}</p>
                <div className='flex-row-container' style={{ justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                    {arr.map((item, index) => {
                        return (<div style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '10px' }} className='shopitem' key={item.value}>
                            <p style={{ textAlign: 'center', paddingRight: '10px' }} className={(selectitem && selectitem.value == item.value) ? 'select11' : 'unselect'} onClick={_self.clickselect.bind(_self, item)}> {item.text}
                            </p></div>)
                    })}
                </div>

                <p className='itemname' style={{ marginTop: '10px' }}>{'充值说明:1元=10泰哈点券,可体验Leadshub App配套的轮胎检测设备一天'}</p>
                <button className="pr-button" onClick={this.getPayInforMation}>{'支付'}</button>
            </div>
        )
    }


    clickselect(item) {


        this.setState({ selectitem: item })

    }

    
    wxconfig() {

        let appId = global.constants.wxappid;
        let appseb = global.constants.secret;
        let url = window.location.href;


        Api.getsha1code({ params: { url: url } }).then(res => {
            if (res.data.code == 0) {

                let data = res.data.data
                let nonceStr = data.nonceStr
                let signature = data.signature
                let time = data.timestamp
                window.wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: appId, // 必填，公众号的唯一标识
                    timestamp: time, // 必填，生成签名的时间戳
                    nonceStr: nonceStr, // 必填，生成签名的随机串
                    signature: signature,// 必填，签名
                    jsApiList: ['chooseWXPay',] // 必填，需要使用的JS接口列表
                });
                window.wx.ready(function () {
                    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。



                });

            }

        })


    }
   
   //向服务器发送支付请求创建订单并且获得订单信息 
   getPayInforMation=()=>{
    let {
        username,
        selectitem
    } = this.state
    if(!username){
      alert('账号不能为空')
      return
    }
   
    if(!selectitem){
       alert('请选择充值金额')
        return  
    }

     let params={account:username,total_fee:selectitem.value*100,body:'点券充值,可换取泰哈珀设备的使用权限'} 
     Api.getPayInforMation(params).then(res=>{
          if(res.data.code==0){
               this.toPay(res.data.data)
          } else{
              alert(res.data.message)
          }
     })

   }

  
   //调用微信客户端完成支付
  toPay(data){
      let str=data.prepay_id
    window.wx.chooseWXPay({
        timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: data.nonceStr  , // 支付签名随机串，不长于 32 位
        package: str, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: data.paySign, // 支付签名
        success: function (res) {
          // 支付成功后的回调函数
         alert('充值成功')   
        }
      });
  }  

   

    wxrz() {

        let code = this.getQueryString('code')
        let wxappid = global.constants.wxappid
        let secret = global.constants.secret

        let redirect_uri1 = this.props.store.rootUrl + 'person/pay/Shop'
        let rurl = encodeURI(redirect_uri1)
        console.log(rurl)

        if (code) {
            Api.getUserInformation({ code: code })
                .then(res => {
                    console.log(res)
                    if (res.data.code == 0) {
                        let data = res.data.data
                        sessionStorage.setItem('openid', data.openid)

                        window.location.href = redirect_uri1

                    } else {
                        let wxrzurl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxappid}&redirect_uri=${rurl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
                        window.location.href = wxrzurl;
                    }

                })


        } else {
            let wxrzurl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxappid}&redirect_uri=${rurl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
            window.location.href = wxrzurl;
        }


    }



    isMobileNumber(phone) {
        let flag = false;
        let message = "";
        let myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(15[0-3]{1})|(15[4-9]{1})|(18[0-9]{1})|(199))+\d{8})$/;
        if (phone == '') {
            // console.log("手机号码不能为空");
            message = "手机号码不能为空！";
        } else if (phone.length != 11) {
            //console.log("请输入11位手机号码！");
            message = "请输入11位手机号码！";
        } else if (!myreg.test(phone)) {
            //console.log("请输入有效的手机号码！");
            message = "请输入有效的手机号码！";
        } else {
            flag = true;
        }
        if (message != "") {
            alert(message);
        }
        return flag;
    }
    getQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURI(r[2]); return null;
    }


}



// WEBPACK FOOTER //
// ./src/views/person/pay/shop.js